
export default {
  props: {
    widget: {type: Object, required: true},
    snapshot: {type: Boolean, default: false}
  },
  computed: {
    show_direction() {
      return ['up', 'down'].includes(this.widget.direction)
    }
  },
  methods: {
    fitText() {
      return this.$refs.value.fitText()
    }
  }
}
